














































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import Button from "@/components/Button.vue";
import CardContainer from "@/components/CardContainer.vue";
import InputElement from "@/components/InputElement.vue";
import ToastMessage from "@/components/ToastMessage.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import ProductCard from "@/components/ProductCard.vue";
import ProductCardInner from "@/components/ProductCardInner.vue";
import ProductCardContainer from "@/components/ProductCardContainer.vue";
import FilterTab from "@/components/FilterTab.vue";
import QuantityCounter from "@/components/QuantityCounter.vue";
import SummaryLine from "@/components/SummaryLine.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import SVGIcon from "@/components/SVGIcon.vue";
import InputRadio from "@/components/InputRadio.vue";
import TimeslotSelector from "@/components/TimeslotSelector.vue";

const filterList = [{ name: "enis" }, { name: "enis2" }, { name: "enis3" }];

@Component({
  components: {
    Button,
    TimeslotSelector,
    CardContainer,
    InputElement,
    ToastMessage,
    ProgressBar,
    ProductCard,
    ProductCardInner,
    ProductCardContainer,
    FilterTab,
    QuantityCounter,
    SummaryLine,
    Header,
    Footer,
    InputRadio
  },
})
export default class UIKit extends Vue {}
